import React from 'react';
import { Star } from 'lucide-react';

interface StarRatingProps {
    rating: number;
    starSize?: string;
    showLabel?: boolean;
    labelClassName?: string;
}

export const StarRating: React.FC<StarRatingProps> = ({ 
    rating, 
    starSize = "w-3.5 h-3.5", 
    showLabel = true,
    labelClassName = "text-xs font-semibold text-muted-foreground ml-1"
}) => (
    <div className="flex items-center gap-1">
        {[1, 2, 3, 4, 5].map((star) => (
            <Star
                key={star}
                className={`${starSize} ${star <= rating ? 'text-amber-400 fill-amber-400' : 'text-muted-foreground/30'}`}
            />
        ))}
        {showLabel && <span className={labelClassName}>{rating}/5</span>}
    </div>
);
